import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "notAvailable",
  "use": "notAvailable-usage",
  "viewBox": "0 -2 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 -2 16 17\" id=\"notAvailable\"><path fill=\"#fff\" stroke=\"#fff\" stroke-width=\"2\" d=\"M7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1z\" /><path fill=\"#A4A4AD\" fill-rule=\"evenodd\" d=\"M4 7a3 3 0 1 0 6 0 3 3 0 0 0-6 0zm3-5a5 5 0 1 0 0 10A5 5 0 0 0 7 2z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol